import { render } from "./GiftInput.vue?vue&type=template&id=14214eb8&scoped=true"
import script from "./GiftInput.vue?vue&type=script&lang=js"
export * from "./GiftInput.vue?vue&type=script&lang=js"

import "./GiftInput.vue?vue&type=style&index=0&id=14214eb8&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14214eb8"]])

export default __exports__